import { setStorageJsonValue, SUPERSTORE_NAMESPACES, SUPERSTORE_STORAGE_ITEMS, SUPERSTORE_STORAGE_KEYS } from '../../../utils/superStoreUtils';
import { clearPushSubscriptionChangedEvent } from './serviceWorkerMessages';
import { apiClientWithMiddleware } from '../../../api/utils';
import { getPortalId } from '../../../utils/getPortalId';
const persistLastSubscriptionTime = () => {
  return setStorageJsonValue({
    namespace: SUPERSTORE_NAMESPACES.NOTIFICATION,
    storageKey: SUPERSTORE_STORAGE_KEYS.BROWSER,
    storageItem: SUPERSTORE_STORAGE_ITEMS.LAST_PUSH_SUBSCRIBE_TIME,
    value: Date.now()
  });
};
const persistNewSubscriptionState = () => {
  return Promise.allSettled([persistLastSubscriptionTime(), clearPushSubscriptionChangedEvent()]);
};

/**
 * Provide the new service worker push subscription to the backend to connect the two
 * Store the last subscribed time so that lifetime can be checked elsewhere
 */
export const subscribeToPushNotifications = async pushSubscription => {
  const subscribed = await apiClientWithMiddleware().postWithResponse(`/notification-station/general/v1/browser/subscription?portalId=${getPortalId()}`, {
    data: pushSubscription
  });
  return await (subscribed ? persistNewSubscriptionState() : Promise.reject(new Error('notification station subscription request responded with false')));
};